/**
 * Areas of Ahmedabad grouped by AMC zone. The server reads this same file
 * for help-request routing. Values are stored as-is — never rename an entry.
 */
import AHMEDABAD_AREA_GROUPS_JSON from './ahmedabadAreas.json';

export const GENDERS = ['Male', 'Female', 'Transgender'];

/** Stored values (API / DB). */
export const AGE_CATEGORIES = [
  'Vidyarthi Sena',
  'Young Brigade',
  'Jagat Janani Matru Shakti',
  'Samajik Aadhar Stambh',
  'Samaj Pathdarshak Vadilvrund',
];

/** Display labels with age gap for selects. */
export const AGE_CATEGORY_OPTIONS = [
  { value: 'Vidyarthi Sena', label: 'Vidyarthi Sena (6 to 16 years)' },
  { value: 'Young Brigade', label: 'Young Brigade (17 to 26 years)' },
  {
    value: 'Jagat Janani Matru Shakti',
    label: 'Jagat Janani Matru Shakti (All age females)',
  },
  {
    value: 'Samajik Aadhar Stambh',
    label: 'Samajik Aadhar Stambh (Business persons up to 56 years)',
  },
  {
    value: 'Samaj Pathdarshak Vadilvrund',
    label: 'Samaj Pathdarshak Vadilvrund (57 years onwards)',
  },
];

export const AGE_CATEGORY_LABELS = Object.fromEntries(
  AGE_CATEGORY_OPTIONS.map((c) => [c.value, c.label])
);

export const VOLUNTEERING_LEVELS = [
  'State Level',
  'District Level',
  'City Level',
  'Taluka Level',
  'Village Level',
  'Ward Level',
];

export const AVAILABILITY_OPTIONS = [
  'Flexible timing',
  'Part time',
  'Full time',
  'Weekends',
  'Week days',
];

/** Area dropdown groups. Kept in ahmedabadAreas.json so the API can use the same names. */
export const AHMEDABAD_AREA_GROUPS = AHMEDABAD_AREA_GROUPS_JSON;

export const AHMEDABAD_AREAS = AHMEDABAD_AREA_GROUPS.flatMap((g) => g.areas);


export const SKILL_OPTIONS = [
  'First Aid',
  'Driving',
  'Medical',
  'Logistics',
  'Crowd management',
  'Cooking / food service',
  'Documentation',
  'Translation',
];

export const REFERRAL_ID_RE = /^SS-\d{5}$/i;
export const INDIAN_MOBILE_RE = /^[6-9]\d{9}$/;
export const PINCODE_RE = /^\d{6}$/;
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const PHOTO_MAX_BYTES = 5 * 1024 * 1024;
/** Must match server/lib/profile.js */
export const MIN_PASSWORD_LENGTH = 8;

export function normalizeMobile(raw) {
  const digits = String(raw || '').replace(/\D/g, '');
  if (digits.length === 12 && digits.startsWith('91')) return digits.slice(2);
  if (digits.length === 11 && digits.startsWith('0')) return digits.slice(1);
  return digits;
}

export function calcAgeFromBirthDate(isoDate) {
  if (!isoDate) return null;
  const d = new Date(`${isoDate}T00:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - d.getFullYear();
  const m = today.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age -= 1;
  return age;
}

/**
 * Derive age category from age + gender (not user-editable).
 * Females of any age → Jagat Janani Matru Shakti.
 * Male / Transgender follow age bands.
 */
export function suggestAgeCategory(age, gender) {
  if (!gender) return '';
  if (gender === 'Female') return 'Jagat Janani Matru Shakti';
  if (age == null || age < 0) return '';
  if (age >= 6 && age <= 16) return 'Vidyarthi Sena';
  if (age >= 17 && age <= 26) return 'Young Brigade';
  if (age >= 27 && age <= 56) return 'Samajik Aadhar Stambh';
  if (age >= 57) return 'Samaj Pathdarshak Vadilvrund';
  return '';
}

export function isAllowedImageFile(file) {
  if (!file) return false;
  if (file.type && file.type.startsWith('image/')) return true;
  return /\.(jpe?g|png|gif|webp|heic|heif|bmp)$/i.test(file.name || '');
}
